<template>
  <DialogBase
    :visible.sync="dialogVisible"
    title="Thông tin bổ sung"
    dialog-class="sk-dialog--lg"
    :use-panel="false"
    :show-cancel="false"
    :show-confirm="false"
    :close-on-click-modal="false"
    @closed="handleClosed"
  >
    <div class="aid-dialog" v-loading="loading">
      <el-form
        ref="dataForm"
        :model="dataForm"
        :rules="formRules"
        label-position="top"
      >
        <div class="sk-panel aid-dialog__panel">
          <div class="sk-panel-head">
            <div class="sk-panel-icon"><i class="el-icon-user" /></div>
            <div>
              <p class="sk-panel-title">Thông tin điểm danh bổ sung</p>
              <p class="sk-panel-subtitle" v-if="studentName">Học sinh: {{ studentName }}</p>
              <p class="sk-panel-subtitle">Đợt {{ turn }} - Tháng {{ month }}/{{ year }}</p>
            </div>
          </div>

          <div class="aid-dialog__head">
            <div>Tiêu đề</div>
            <div>Tháng {{ month }}</div>
            <div>{{ monthBeforeLabel }}</div>
            <div>Bổ sung</div>
          </div>

          <div class="aid-dialog__row" v-for="item in metricRows" :key="item.key">
            <div class="aid-dialog__cell aid-dialog__cell--title">{{ item.label }}</div>
            <div class="aid-dialog__cell">{{ valueOrZero(dataForm[item.totalKey]) }}</div>
            <div class="aid-dialog__cell">{{ valueOrZero(dataForm[item.monthBeforeKey]) }}</div>
            <div class="aid-dialog__cell aid-dialog__cell--edit">
              <el-form-item :prop="item.valueKey" class="aid-dialog__form-item">
                <el-input-number
                  v-model="dataForm[item.valueKey]"
                  :min="0"
                  :step="1"
                  size="small"
                  controls-position="right"
                  class="sk-u-w-full"
                />
              </el-form-item>
            </div>
          </div>
        </div>

        <div class="sk-panel aid-dialog__panel sk-u-mt-12">
          <div class="sk-panel-head">
            <div class="sk-panel-icon sk-panel-icon--success"><i class="el-icon-document" /></div>
            <div>
              <p class="sk-panel-title">Nội dung ghi chú</p>
              <p class="sk-panel-subtitle">Ghi chú hiển thị đồng bộ cho phiếu thu nháp</p>
            </div>
          </div>

          <el-form-item label="Ghi chú" prop="note">
            <el-input
              v-model="dataForm.note"
              type="textarea"
              :rows="3"
              maxlength="500"
              show-word-limit
              placeholder="Nhập ghi chú bổ sung"
            />
          </el-form-item>
        </div>
      </el-form>
    </div>

    <template #footer>
      <div class="sk-dialog__footer">
        <el-button class="btn-cancel" plain @click="handleClose">Hủy</el-button>
        <el-button class="btn-save" type="primary" :loading="saving" @click="handleSave">Lưu</el-button>
      </div>
    </template>
  </DialogBase>
</template>

<script>
import DialogBase from "@/components/DialogBase.vue";

const createDefaultDataForm = () => ({
  arriveT2t6: 0,
  arriveT7: 0,
  arriveCn: 0,
  absentCpT2t6: 0,
  absentKpT2t6: 0,
  absentCpT7: 0,
  absentKpT7: 0,
  leaveLater: 0,
  quantityDate: 0,
  note: "",
  arriveT2t6Total: 0,
  arriveT7Total: 0,
  arriveCnTotal: 0,
  absentCpT2t6Total: 0,
  absentKpT2t6Total: 0,
  absentCpT7Total: 0,
  absentKpT7Total: 0,
  leaveLaterTotal: 0,
  quantityDateTotal: 0,
  arriveT2t6TotalMonthBefore: 0,
  arriveT7TotalMonthBefore: 0,
  arriveCnTotalMonthBefore: 0,
  absentCpT2t6TotalMonthBefore: 0,
  absentKpT2t6TotalMonthBefore: 0,
  absentCpT7TotalMonthBefore: 0,
  absentKpT7TotalMonthBefore: 0,
  leaveLaterTotalMonthBefore: 0,
  quantityDateTotalMonthBefore: 0,
});

export default {
  name: "AdditionalInfoDraftDialog",
  components: { DialogBase },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    month: {
      type: Number,
      default: null,
    },
    year: {
      type: Number,
      default: null,
    },
    turn: {
      type: Number,
      default: null,
    },
    studentName: {
      type: String,
      default: "",
    },
    info: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      saving: false,
      dataForm: createDefaultDataForm(),
      formRules: {
        arriveT2t6: [{ validator: this.validateNonNegativeInteger, trigger: "change" }],
        arriveT7: [{ validator: this.validateNonNegativeInteger, trigger: "change" }],
        arriveCn: [{ validator: this.validateNonNegativeInteger, trigger: "change" }],
        absentCpT2t6: [{ validator: this.validateNonNegativeInteger, trigger: "change" }],
        absentKpT2t6: [{ validator: this.validateNonNegativeInteger, trigger: "change" }],
        absentCpT7: [{ validator: this.validateNonNegativeInteger, trigger: "change" }],
        absentKpT7: [{ validator: this.validateNonNegativeInteger, trigger: "change" }],
        leaveLater: [{ validator: this.validateNonNegativeInteger, trigger: "change" }],
        quantityDate: [{ validator: this.validateNonNegativeInteger, trigger: "change" }],
      },
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
    monthBeforeLabel() {
      if (!this.month || !this.year) return "Tháng trước";
      if (this.month === 1) return `Tháng 12/${this.year - 1}`;
      return `Tháng ${this.month - 1}/${this.year}`;
    },
    metricRows() {
      return [
        { key: "arriveT2t6", label: "Học T2-T6", totalKey: "arriveT2t6Total", monthBeforeKey: "arriveT2t6TotalMonthBefore", valueKey: "arriveT2t6" },
        { key: "arriveT7", label: "Học T7", totalKey: "arriveT7Total", monthBeforeKey: "arriveT7TotalMonthBefore", valueKey: "arriveT7" },
        { key: "arriveCn", label: "Học CN", totalKey: "arriveCnTotal", monthBeforeKey: "arriveCnTotalMonthBefore", valueKey: "arriveCn" },
        { key: "absentCpT2t6", label: "Nghỉ có phép (T2-T6)", totalKey: "absentCpT2t6Total", monthBeforeKey: "absentCpT2t6TotalMonthBefore", valueKey: "absentCpT2t6" },
        { key: "absentKpT2t6", label: "Nghỉ không phép (T2-T6)", totalKey: "absentKpT2t6Total", monthBeforeKey: "absentKpT2t6TotalMonthBefore", valueKey: "absentKpT2t6" },
        { key: "absentCpT7", label: "Nghỉ có phép (T7)", totalKey: "absentCpT7Total", monthBeforeKey: "absentCpT7TotalMonthBefore", valueKey: "absentCpT7" },
        { key: "absentKpT7", label: "Nghỉ không phép (T7)", totalKey: "absentKpT7Total", monthBeforeKey: "absentKpT7TotalMonthBefore", valueKey: "absentKpT7" },
        { key: "leaveLater", label: "Đón muộn", totalKey: "leaveLaterTotal", monthBeforeKey: "leaveLaterTotalMonthBefore", valueKey: "leaveLater" },
        { key: "quantityDate", label: "Số ngày theo lịch hàng tháng", totalKey: "quantityDateTotal", monthBeforeKey: "quantityDateTotalMonthBefore", valueKey: "quantityDate" },
      ];
    },
  },
  watch: {
    visible(val) {
      if (val) {
        this.hydrateDataForm(this.info);
      }
    },
    info: {
      deep: true,
      handler(val) {
        if (this.visible) {
          this.hydrateDataForm(val);
        }
      },
    },
  },
  methods: {
    valueOrZero(value) {
      if (value === null || value === undefined || value === "") return 0;
      return value;
    },

    normalizeNumber(value) {
      const num = Number(value);
      if (Number.isNaN(num) || num < 0) return 0;
      return Math.floor(num);
    },

    hydrateDataForm(info) {
      const source = info || {};
      const base = createDefaultDataForm();
      const next = { ...base, ...source };

      this.metricRows.forEach((item) => {
        next[item.valueKey] = this.normalizeNumber(next[item.valueKey]);
        next[item.totalKey] = this.normalizeNumber(next[item.totalKey]);
        next[item.monthBeforeKey] = this.normalizeNumber(next[item.monthBeforeKey]);
      });

      this.dataForm = next;
      this.$nextTick(() => {
        if (this.$refs.dataForm) {
          this.$refs.dataForm.clearValidate();
        }
      });
    },

    validateNonNegativeInteger(rule, value, callback) {
      const num = Number(value);
      if (Number.isNaN(num) || num < 0) {
        callback(new Error("Giá trị phải lớn hơn hoặc bằng 0"));
        return;
      }
      callback();
    },

    handleClose() {
      this.dialogVisible = false;
    },

    handleClosed() {
      if (this.$refs.dataForm) {
        this.$refs.dataForm.resetFields();
      }
      this.dataForm = createDefaultDataForm();
      this.$emit("close");
    },

    handleSave() {
      this.$refs.dataForm.validate(async (valid) => {
        if (!valid) return;

        this.saving = true;
        try {
          const payload = { ...this.dataForm };
          this.$emit("save", payload);
          this.$emit("saved", payload);
          this.handleClose();
        } finally {
          this.saving = false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/sk-dialog";

.aid-dialog {
  font-family: Inter, Arial, Helvetica, sans-serif;

  &__panel {
    border-radius: 14px;
  }

  &__subtitle {
    margin: 0 0 4px;
    font-size: 13px;
    color: #64748b;
  }

  &__head {
    display: grid;
    grid-template-columns: 2fr 1fr 1.1fr 1.2fr;
    gap: 8px;
    align-items: center;
    font-weight: 700;
    color: #1e293b;
    border-bottom: 1px solid #e2e8f0;
    padding: 8px 0;

    > div {
      text-align: center;
    }

    > div:first-child {
      text-align: left;
    }
  }

  &__row {
    display: grid;
    grid-template-columns: 2fr 1fr 1.1fr 1.2fr;
    gap: 8px;
    align-items: center;
    border-bottom: 1px solid #f1f5f9;
    padding: 8px 0;
  }

  &__cell {
    color: #475569;
    font-size: 13px;
    text-align: center;

    &--title {
      color: #1e293b;
      font-weight: 600;
      text-align: left;
    }

    &--edit {
      min-width: 120px;
      justify-self: center;
    }
  }

  &__form-item {
    margin-bottom: 0;
  }

  &__last-form-item {
    margin-bottom: 0;
  }
}

/deep/ .aid-dialog .el-input-number {
  width: 100%;
}

@media (max-width: 768px) {
  .aid-dialog {
    &__head,
    &__row {
      grid-template-columns: 1.8fr 0.9fr 0.9fr 1.1fr;
      gap: 6px;
      font-size: 12px;
    }
  }
}
</style>
